import * as React from "react";
const SvgFiRrDocumentPaid = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-document-paid_svg__a)">
      <path
        fill="#062147"
        d="M13.257 12.001c-.757 0-1.281.587-1.385 1.167l-1.2 5.976a.716.716 0 1 0 1.406.272l.166-.889h2.006l.157.883a.716.716 0 0 0 .705.591h.01a.716.716 0 0 0 .701-.86l-1.221-5.947c-.12-.668-.589-1.192-1.346-1.192zm-.645 5 .624-3.295.638 3.295zM17.6 12a.8.8 0 0 1 .8.8v6.4a.8.8 0 1 1-1.6 0v-6.4a.8.8 0 0 1 .8-.8m-9.557 0H6.799a.8.8 0 0 0-.8.8v6.4a.8.8 0 1 0 1.6 0V17h.5a2.5 2.5 0 0 0 2.5-2.452C10.625 13.147 9.445 12 8.043 12m.056 3.4h-.5v-1.8h.5c.496 0 .9.404.9.9s-.404.9-.9.9M21.7 12h-1.5a.8.8 0 0 0-.8.8v6.4a.8.8 0 0 0 .8.8h1.5a2.3 2.3 0 0 0 2.3-2.3v-3.4a2.3 2.3 0 0 0-2.3-2.3m.7 5.7a.7.7 0 0 1-.7.7H21v-4.802h.7a.7.7 0 0 1 .7.7V17.7M18 22H5c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h4.515q.245 0 .485.023V7c0 1.654 1.346 3 3 3h5.813a1 1 0 0 0 .969-1.248 7 7 0 0 0-1.833-3.217L14.465 2.05A6.96 6.96 0 0 0 9.515 0H5C2.243 0 0 2.243 0 5v14c0 2.757 2.243 5 5 5h13a1 1 0 1 0 0-2M12 2.659c.379.218.733.488 1.051.806l3.484 3.486c.314.314.584.667.804 1.05H13c-.551 0-1-.449-1-1z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-document-paid_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDocumentPaid;
